// extracted by mini-css-extract-plugin
export default {"SectionTitle":"SectionTitle_SectionTitle__DZzyD"};